import React from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { loadSecondaryMenuComponent } from "./loader";
import { PageContextUtils } from "../../utils";

const SecondaryMenu = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const { name } = PageContextUtils.getClientProviderData();
  const BrandSecondaryMenu = loadSecondaryMenuComponent(brandId, name);
  return BrandSecondaryMenu && <BrandSecondaryMenu />;
};

export default React.memo(SecondaryMenu);
